export const GOOGLE_CONFIG = {
    CLIENT_ID: '691423973656-h1ui51ggtq34osmuqq28o8sgtp7m57qm.apps.googleusercontent.com',
    REDIRECT_URI: 'app.plii:/oauth2redirect',
};
